export const VULNERABILITY_JIRA_TICKETS_LABELS = {
  SECTION_LABEL: 'Jira ticket',
  NO_TICKETS: 'No ticket yet',
  CREATE_TICKET: 'Create ticket',
  STATUS: 'Status',
  ASSIGNEE: 'Assignee',
  ISSUE_TYPE: 'Issue type',
  UPDATED: 'Updated',
  OPEN_TICKET: 'Open ticket in Jira',
  DISCONNECTED_ALERT_TITLE: 'Jira is disconnected',
  DISCONNECTED_ALERT_BODY: 'Reconnect to see live ticket status.'
};

// Poll Jira ticket updates once per minute.
export const VULNERABILITY_JIRA_TICKETS_POLL_INTERVAL_MS = 60_000;
